import styled from 'styled-components';
import SVG from 'react-inlinesvg';

export const Status = styled(SVG)`
  height: 56px;
  width: 56px;
  margin-bottom: 32px;
`;

export const CenteredColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
